export const paywallMixin = {
  computed: {
    isBasePlanValid() {
      return this.basePlan && !this.basePlan.error;
    },
    needLimitations() {
      const companyId = localStorage.getItem('FYGR_COMPANY');
      return (
        !this.subscription.bypass &&
        !(this.subscription.trial && !this.subscription.free_trial_version) &&
        !this.companies[companyId][2] &&
        !this.companies[companyId][3]
      );
    },
    planIncludeReached() {
      return (type) => {
        if (type === 'user') {
          return (
            (this.isBasePlanValid ? this.basePlan.included_users : 1) +
              this.basePlan.current_users <=
            this.validUsers.length
          );
        }
        if (type === 'bank') {
          return (
            (this.isBasePlanValid ? this.basePlan.included_banks : 1) +
              this.basePlan.current_banks <=
            this.validBanks.length
          );
        }
        return false;
      };
    },
    planLimitReached() {
      return (type) => {
        if (type === 'scenario') {
          return (
            (this.isBasePlanValid ? this.basePlan.max_scenarios : 1) <=
            this.scenarios.length
          );
        }
        if (type === 'user') {
          return (
            (this.isBasePlanValid ? this.basePlan.max_users : 1) <=
            this.validUsers.length
          );
        }
        if (type === 'bank') {
          return (
            (this.isBasePlanValid ? this.basePlan.max_banks : 1) <=
            this.validBanks.length
          );
        }
        return false;
      };
    },
    planMax() {
      return (type) => {
        if (type === 'scenario') {
          return this.basePlan.max_scenarios;
        }
        if (type === 'user') {
          return this.basePlan.max_users;
        }
        return 1;
      };
    },
    areCustomPermissionsAllowedByPlan() {
      return this.basePlan?.custom_permissions;
    },
    isCompanyV1OrNotTrial() {
      return (
        !this.subscription?.free_trial_version && !this.subscription?.trial
      );
    },
    isCompanyV1NoSubscription() {
      return (
        !this.subscription?.has_subscription &&
        this.subscription?.free_trial_version
      );
    },
  },
  methods: {
    checkLimits(type) {
      if (this.needLimitations && this.planLimitReached(type)) {
        if (this.basePlan && this.basePlan.plan_family === 'entreprise') {
          if (type === 'bank') {
            this.isUser = false;
            this.customMax = this.basePlan.max_banks;
            this.customType = type;
          } else {
            this.$emit('customMax', {amount: this.planMax(type), type});
          }
          this.actionSetTooManyConnections(true);
          return true;
        }
        this.basePlan.type = type;
        if (type === 'bank') {
          this.showUpgradePopup = true;
        } else {
          this.$emit('unlock', this.basePlan);
        }
        return true;
      }
      if (this.needLimitations && this.planIncludeReached(type)) {
        this.basePlan.type = type;
        if (type === 'user') {
          this.$emit('additionalUser', {
            ...this.basePlan,
            to_add: this.validUsers.length,
          });
        } else {
          this.additionalBank = this.basePlan.additional_bank_plan.unit_price;
        }
        return true;
      }
      return false;
    },
  },
};

export default {paywallMixin};
